import { getFunctions, httpsCallable } from 'firebase/functions';
import { 
  CreateLinkTokenResponse,
  GetAccountsResponse,
  ExchangeTokenRequest,
  DisconnectAccountRequest,
  PlaidAccountBalance
} from '@/types/plaid';

const functions = getFunctions();

export const createLinkToken = httpsCallable<{}, CreateLinkTokenResponse>(functions, 'createLinkToken');
export const exchangeToken = httpsCallable<ExchangeTokenRequest, { success: boolean }>(functions, 'exchangeToken');
export const getAccounts = httpsCallable<{}, GetAccountsResponse>(functions, 'getAccounts');
export const disconnectAccount = httpsCallable<DisconnectAccountRequest, { success: boolean }>(functions, 'disconnectAccount');
export const syncBalances = httpsCallable<{}, { success: boolean }>(functions, 'syncBalances');
export const getAccountBalances = httpsCallable<{}, { accounts: PlaidAccountBalance[] }>(functions, 'getAccountBalances');
export const syncTransactions = httpsCallable<{ plaidItemId: string }, { success: boolean, added: number, modified: number, removed: number, cursorUpdated: boolean }>(functions, 'syncTransactions'); 